module.exports = __webpack_public_path__ + "img/xinfan.af7e5e40.png";